<template>
  <div>
    <!-- 新评论 -->
    <el-form
      v-loading="loading"
      :model="form"
      ref="form"
      :rules="itemRules"
      label-width="auto"
    >
      <!-- 只有report可以选择 -->
      <el-form-item label="类型" prop="type">
        <el-radio-group v-model="form.type">
          <el-radio-button label="0">好评</el-radio-button>
          <el-radio-button label="1">中评</el-radio-button>
          <el-radio-button label="2">差评</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <!-- 只有report有标题，reply应只有内容 -->
      <el-form-item label="标题" prop="title">
        <el-input v-model="form.title"></el-input>
      </el-form-item>
      <el-form-item label="内容" prop="content">
        <Editor
          ref="editor"
          height="30em"
          previewStyle="vertical"
          :options="editorOptions"
        ></Editor>
      </el-form-item>
    </el-form>

    <div class="discussion-footer">
      <el-button type="primary" @click="submitForm()">发 布</el-button>
    </div>
  </div>
</template>

<script>
import { Editor } from "@toast-ui/vue-editor";

export default {
  props: {
    scriptId: {
      type: String,
      required: true,
    },
  },
  components: {
    Editor,
  },
  data() {
    return {
      loading: false,
      form: {
        type: "0",
        title: null,
        content: null,
      },

      itemRules: {
        type: [{ required: true, message: "必须选择反馈类型" }],
        title: [{ required: true, message: "标题不能为空" }],
        content: [{ required: true, message: "回复不能为空" }],
      },

      editorOptions: {
        language: "zh-cn",
        toolbarItems: [
          "heading",
          "bold",
          "italic",
          "strike",
          "divider",
          "hr",
          "quote",
          "divider",
          "ul",
          "ol",
          "task",
          "indent",
          "outdent",
          "divider",
          "table",
          "link",
          "divider",
          "code",
          "codeblock",
        ],
      },
    };
  },
  methods: {
    getHtml() {
      this.form.content = this.$refs.editor.invoke("getHtml");
    },
    submitForm() {
      //todo 判断是否已登录
      this.getHtml();
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.loading = true;
          await this.sendNewReport();
          this.loading = false;
        }
      });
    },
    async sendNewReport() {
      //发送请求
      const response = await this.axios.post(
        `/api/reportScript/${this.scriptId}`,
        this.stringify(this.form)
      );

      //处理响应
      switch (response.data.code) {
        case 200: //发送成功后返回
          this.$message({
            message: "发送成功！",
            type: "success",
          });
          this.$emit("successSendNewReport");
          this.$refs.form.resetFields();
          this.$refs.editor.invoke("setMarkdown", "");

          break;

        case -100: //验证码错误
          this.$message({
            message: "发送失败",
            type: "error",
          });
          break;
      }
    },
  },
};
</script>

<style scoped>
.discussion-footer {
  display: flex;
  justify-content: center;
}

.discussion-footer .el-button {
  width: 10em;
}
</style>